import './ImageDragAndDropUploader.scss';

import BadgeOld from 'components/BadgeOld/BadgeOld';
import DragAndDropImage from 'images/drag&drop.png';
import { observer } from 'mobx-react-lite';
import { useDropzone } from 'react-dropzone';
import { useEffect } from 'react';
import { useStores } from 'index';

type Props = {
  badgeText?: string;
  badgeIcon?: React.ReactNode;
};

export const ImageDragAndDropUploader = observer(({ badgeText, badgeIcon }: Props) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const es = useStores().trackmanEventsEditorStore;

  useEffect(() => {
    if (!es.eventItem.id && es.isSaving) {
      delete es.eventItem.imageData;
      es.imagePreview = '';
      es.uploadedImageAccepted = false;
    }
  }, [es.eventItem, es, es.isSaving]);

  useEffect(() => {
    if (!acceptedFiles.length) {
      es.imagePreview = es.eventItem.imageUrl || '';
      es.uploadedImageAccepted = false;
      return;
    }

    const objectUrl = URL.createObjectURL(acceptedFiles[0]);
    es.imagePreview = objectUrl;

    return () => URL.revokeObjectURL(objectUrl);
  }, [acceptedFiles, es]);

  return (
    <div className='image-uploader'>
      {!es.imagePreview && !es.eventItem.imageUrl && !es.isVideoIdSelected ? (
        <div {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />
          <img src={DragAndDropImage} alt='drag and drop placeholder' />
        </div>
      ) : es.isVideoIdSelected ? (
        <div className='image-placeholder' />
      ) : (
        <div className='preview'>
          <img
            src={es.eventItem.imageUrl ? es.eventItem.imageUrl : es.imagePreview}
            alt={es.eventItem.imageUrl ? `${es.eventItem.title} event illustration` : acceptedFiles[0]?.name}
          />
          {es.eventItem.premiumEvent ? <BadgeOld badgeText={badgeText ? badgeText : ''} badgeIcon={badgeIcon} /> : null}
        </div>
      )}
      {!es.eventItem.imageUrl && es.imagePreview && !es.uploadedImageAccepted ? (
        <div className='actions'>
          <button
            onClick={() => {
              if (acceptedFiles.length) {
                es.eventItem.imageData = {
                  id: '',
                  data: acceptedFiles[0],
                };
                es.uploadedImageAccepted = true;
              }
            }}
            className='styled-button primary'
          >
            Accept
          </button>
          <button
            onClick={() => {
              es.imagePreview = '';
              es.uploadedImageAccepted = false;
            }}
            className='styled-button secondary'
          >
            Cancel
          </button>
        </div>
      ) : es.uploadedImageAccepted || es.eventItem.imageUrl ? (
        <div className='actions change-image'>
          <button
            onClick={() => {
              es.imagePreview = '';
              es.uploadedImageAccepted = false;
              delete es.eventItem.imageData;
              es.eventItem.imageUrl = '';
            }}
            className='styled-button secondary'
          >
            Change image
          </button>
        </div>
      ) : null}
    </div>
  );
});

export default ImageDragAndDropUploader;
